export default {
  markerColor: "#7DF3B3",
  xAxisLineColor: "#000000",
  labelColor: '#B1B1B1',
  backgroundColor: '#000000'
};